/* eslint-disable */

import { useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { toast } from "react-toastify";

function Cover() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [lastName, setLastName] = useState("");
  const [rights, setRights] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [department, setDepartment] = useState("");
  const [phone, setPhone] = useState("");
  const [departmentsList, setDepartmentsList] = useState(null);


  const handleSignUp = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/sign-up.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name,
          email: email,
          password: password,
          lastName: lastName,
          rights: rights,
          isAdmin: isAdmin,
          department: department,
          phone: phone,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response OK: ", data.message);
        toast.success(`${data.message}`);
      } else {
        console.error("Błąd rejestracji:", data.message);
        toast.error(`${data.message}`);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
      toast.error(`Błąd podczas wysyłania żądania: ${data.message}`);
    }
  };

  const getAllDepartments = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllDepartments");
      const data = await response.json();
      setDepartmentsList(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera DepartmentsList:", error);
      toast.error(`Błąd podczas pobierania danych z serwera DepartmentsList: ${error}`);
    }
  };

  useEffect(() => {
    getAllDepartments();
  }, []);

  return (
    <CoverLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Dołącz do nas dziś
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Wpisz swoje dane się żeby zarejestrować
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Imię"
                variant="standard"
                fullWidth
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Nazwisko"
                variant="standard"
                fullWidth
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                variant="standard"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Hasło"
                variant="standard"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <InputLabel htmlFor="department-select">Dział</InputLabel>
              <Select
                label="Dział"
                variant="standard"
                value={department}
                onChange={(e) => setDepartment(e.target.value)}
                fullWidth
                IconComponent={() => <ArrowDropDownIcon />}
                inputProps={{
                  name: "department",
                  id: "department-select",
                }}
              >
                <MenuItem value="" disabled>
                  Wybierz dział
                </MenuItem>
                  {departmentsList !== null && departmentsList.map((dept) => (
                    <MenuItem key={dept.name} value={dept.name}>
                      {dept.name}
                    </MenuItem>
                ))}

              </Select>
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="tel"
                label="Telefon"
                variant="standard"
                fullWidth
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Uprawnienia do załozenia nowego konta (hasło)"
                variant="standard"
                fullWidth
                value={rights}
                onChange={(e) => setRights(e.target.value)}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox checked={isAdmin} onChange={() => setIsAdmin(!isAdmin)} />
              <MDTypography
                component="a"
                variant="button"
                fontWeight="bold"
                color="info"
                textGradient
              >
                &nbsp;&nbsp;Prawa administratora&nbsp;
              </MDTypography>
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Checkbox />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;I agree the&nbsp;
              </MDTypography>
              <MDTypography
                component="a"
                href="#"
                variant="button"
                fontWeight="bold"
                color="info"
                textGradient
              >
                Terms and Conditions
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth onClick={handleSignUp}>
                sign in
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Masz już konto?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Zaloguj się
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;
